import './sidebar.scss';

import { PropsWithChildren } from 'react';

type SidebarProps = PropsWithChildren<{
  size?: string;
  title?: JSX.Element | string;
  toolbar?: JSX.Element | string;
  action?: JSX.Element | string;
}>;

export function Sidebar({
  size,
  title,
  toolbar,
  action,
  ...props
}: SidebarProps) {
  return (
    <div className={`sidebar${size ? ` sidebar--${size}` : ``}`}>
      {title && (
        <div className="sidebar__header">
          <h2>{title}</h2>
        </div>
      )}

      {toolbar && <div className="sidebar__toolbar">{toolbar}</div>}

      {props.children && (
        <div className="sidebar__content">{props.children}</div>
      )}

      {action && <div className="sidebar__action">{action}</div>}
    </div>
  );
}
